import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import { StudentRegistrationAdminApi } from "../../../api/student-registration-admin/student-registration-admin.api";
import StatusCustom from "../../../components/status/statusCustom";
import { renderStatus } from "../history-online-Admission/enum/admission.enum";
import { StudentApi } from "../../../api/student/student.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import { degreeApi } from "../../../api/degree/degree.api";
import { AcademicYearApi } from "../../../api/academic-year/academic-year.api";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");


    const [data, setData] = useState<any[]>([{}]);
    const [degree, setDegree] = useState<any[]>([]);
    const [faculty, setFaculty] = useState<any[]>([]);
    const [id_degree, set_id_degree] = useState<any>("ALL");
    const [id_faculty, set_id_faculty] = useState<any>("ALL");
    const [status,setStatus] = useState<any>("ALL");

    const [academicYearList, setAcademicYearList] = useState<any[]>([]);

    const [start_year, set_id_start_year] = useState<any>("ALL");
    const [end_year, set_id_end_year] = useState<any>("ALL");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "#",
            width: 100,
            disablePadding: false,
            align: "center",
            label: "#",
        },
        {
            id: "fullname",
            width: 300,
            disablePadding: false,
            align: "start",
            label: "ชื่อ - นามสกุล",
        },

        {
            id: "student_no",
            disablePadding: false,
            align: "center",
            width: 300,
            label: "รหัสประจำตัวนักศึกษา",
        },
        {
            id: "education_level",
            disablePadding: false,
            align: "center",
            width: 200,
            label: "ระดับ",
        },
        {
            id: "course",
            disablePadding: false,
            width: 200,
            align: "center",
            label: "หลักสูตร",
        },
        {
            id: "year_study",
            disablePadding: false,
            align: "center",
            width: 200,
            label: "ปีที่เข้ารับการศึกษา",
        },
        {
            id: "year_graduation",
            disablePadding: false,
            align: "center",
            width: 200,
            label: "ปีที่จบการศึกษา",
        },
        {
            id: "status",
            disablePadding: false,
            align: "center",
            width: 250,
            label: "สถานะ",
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            id_student,
            student_no,
            title,
            student_frist_name,
            student_middle_name,
            student_last_name,
            status,
            student_status,
            id_student_term_payment,
            id_student_register_payment,
            faculty_name,
            degree_name,
            academic_year,
            academic_year_end
        } =
            objData;
        const objRenderData = {
            key: id_student,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label:
                        title +
                        " " +
                        student_frist_name +
                        " " +
                        student_middle_name +
                        " " +
                        student_last_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: student_no || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: degree_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: academic_year || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: academic_year_end || "-",
                },
                // {
                //   option: "TEXT",
                //   align: "center",
                //   label: (
                //     <CustomStatus
                //       label={handleTextStatus(status)}
                //       type="outlined"
                //       color={handleColorStatus(status)}
                //       icon={<FiberManualRecord />}
                //       width="100px"
                //     />

                //   ),
                // },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <StatusCustom
                        disableMaxWidth
                        text={renderStatus(student_status)}
                        type={renderStatus(student_status)}
                    />,
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <IconButton onClick={() => navigate(routeName.admission.student_registration_information_detail.replace(':id', id_student))}>
                            <ArrowForwardIosIcon />
                        </IconButton>
                        {/* <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => navigate(routeName.admission.student_registration_information_view)}
                            onEditClick={() => navigate(routeName.admission.student_registration_information_detail)}
                            onDeleteClick={() => { }}
                        /> */}
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit,
            sortBy: sortBy,
            sortType: sortType,
        };

        if (keyword) query = { ...query, keyword: keyword }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        if (id_degree !== 'ALL') query = { ...query, id_degree: id_degree }
        if (id_faculty !== "ALL") query = { ...query, id_faculty: id_faculty }
        if (start_year !== "ALL") query = { ...query, start_year: start_year }
        if (end_year !== "ALL") query = { ...query, end_year: end_year }
        if (status !== "ALL") query = { ...query, student_status: status }
        await StudentApi.getAllStudents(query).then((res) => {
            if (res.status < 300) {
                const data = res.data;
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
                setData(data.data.items);
            } else {
                setData([]);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [page, pageLimit, sortBy, sortType, keyword, id_degree, id_faculty, start_year, end_year, status])


    useEffect(() => {
        handleGetData()
    }, [handleGetData])
    const getDegree = async () => {
        await degreeApi.getDegree().then((res) => {
            if (res.status < 300) {
                setDegree(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getFaculty = async () => {
        await facultyApi.getFaculty().then((res) => {
            if (res.status < 300) {
                setFaculty(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getAcademicYearList = async () => {
         let query: any = {
            page: 1,
            limit: 1000,
         }
        await AcademicYearApi.getAcademicYearListActive(query).then((res) => {
            if (res.status < 300) {
                setAcademicYearList(res.data?.data.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        getDegree()
        getFaculty()
        getAcademicYearList()
    }, [])

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        set_id_degree,
        id_degree,
        degree,
        set_id_faculty,
        faculty,
        id_faculty,
        start_year,
        set_id_start_year,
        end_year,
        set_id_end_year,
        academicYearList,
        status,
        setStatus

    }
}

export default ManageState